var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import gsap from 'gsap';
import './main.scss';
import { PrimaryButton } from '../buttons/PrimaryButton';
import { Button } from '../CtaButtons';
import parse from 'html-react-parser';
import patternBackgroundImageDesktop from '../../assets/images/HeadlineCTA/Pattern_BG_Desktop_Pattern.png';
import patternBackgroundImageTablet from '../../assets/images/HeadlineCTA/Pattern_BG_Tablet_Pattern.png';
import patternBackgroundImageMobile from '../../assets/images/HeadlineCTA/Pattern_BG_Mobile_Pattern.png';
var data = {
    backgroundSolidColor: '#ffffff',
};
var defaultProps = {
    data: data,
};
var themes = [
    {
        background: '',
        backgroundColor: '#ffffff',
        color: '#000000',
        statsColor: '#0074bd',
        ctaStyle: { backgroundColor: '#005f9e', color: '#ffffff' },
        class: 'white-background-color',
    },
    {
        background: '',
        backgroundColor: '#0074bd',
        color: '#ffffff',
        statsColor: '#ffffff',
        ctaStyle: { backgroundColor: '#ffffff', color: '#005f9e' },
        class: '',
    },
    {
        background: '',
        backgroundColor: '#00818f',
        color: '#ffffff',
        statsColor: '#ffffff',
        ctaStyle: { backgroundColor: '#ffffff', color: '#005f9e' },
        class: '',
    },
    {
        background: '',
        backgroundColor: '#343741',
        color: '#ffffff',
        statsColor: '#ffffff',
        ctaStyle: { backgroundColor: '#ffffff', color: '#005f9e' },
        class: '',
    },
];
var HeadlineCTA = function (_a) {
    var _b = _a.data, template = _b.template, background_type = _b.background_type, headline = _b.headline, description = _b.description, background_color = _b.background_color, background_image = _b.background_image, items = _b.items;
    var chosentheme = themes[0];
    var themeIndex = themes.findIndex(function (_a) {
        var backgroundColor = _a.backgroundColor;
        return backgroundColor.toLowerCase() === (background_color === null || background_color === void 0 ? void 0 : background_color.toLocaleLowerCase());
    });
    var _c = useState(window.innerWidth), width = _c[0], setWidth = _c[1];
    function handleWindowSizeChange() {
        setWidth(window.innerWidth);
    }
    useEffect(function () {
        window.addEventListener('resize', handleWindowSizeChange);
        return function () {
            window.removeEventListener('resize', handleWindowSizeChange);
        };
    }, []);
    var isMobile = width < 768;
    var isTablet = width >= 768 && width < 1024;
    var headlineCTAStatItemsCount = items.length;
    if (background_type == 'pattern') {
        if (isMobile) {
            chosentheme = __assign(__assign({}, themes[1]), { background: "URL(" + patternBackgroundImageMobile + ")", class: 'pattern-background' });
        }
        else if (isTablet) {
            chosentheme = __assign(__assign({}, themes[1]), { background: "URL(" + patternBackgroundImageTablet + ")", class: 'pattern-background' });
        }
        else {
            chosentheme = __assign(__assign({}, themes[1]), { background: "URL(" + patternBackgroundImageDesktop + ")", class: 'pattern-background' });
        }
    }
    else if (background_image) {
        chosentheme = __assign(__assign({}, themes[3]), { background: "URL(" + background_image + ")", class: 'background-image' });
    }
    else if (themeIndex >= 0) {
        chosentheme = themes[themeIndex];
    }
    useEffect(function () {
        var tl = gsap.timeline({
            scrollTrigger: {
                trigger: '.headline-cta-section',
                start: 'top center',
            },
        });
        tl.fromTo(['.headline-cta-text', '.headline-cta-button'], {
            opacity: 0,
            duration: 0.5,
            stagger: 0.5,
        }, {
            opacity: 1,
            duration: 0.5,
            stagger: 0.5,
        });
    }, []);
    return (_jsx(_Fragment, { children: template == 'image-text-cta' ? (_jsxs("div", __assign({ className: "headline-cta-section relative snap-center w-full h-full flex items-center justify-center " + chosentheme.class, style: chosentheme }, { children: [background_image && (_jsx("div", { className: "headline-cta-section-overlay" }, void 0)),
                _jsxs("div", __assign({ className: "headline-cta-section-heading" }, { children: [headline && (_jsx("div", __assign({ className: "headline-cta-section-title" }, { children: parse(headline) }), void 0)),
                        description && (_jsx("div", __assign({ className: "headline-cta-section-description" }, { children: parse(description) }), void 0))] }), void 0),
                _jsx("div", __assign({ className: "headline-cta-section-icon-items-container " + (headlineCTAStatItemsCount == 2 ? 'two-item-view' : '') }, { children: items.map(function (item, index) {
                        return (_jsxs("div", __assign({ className: "headline-cta-section-icon-item " + (headlineCTAStatItemsCount == 2 ? 'two-item-view' : '') }, { children: [item.image ? (_jsx("div", __assign({ className: "headline-cta-section-icon " }, { children: _jsx("img", { src: item.image, alt: "item-" + (index + 1) + "-image" }, void 0) }), void 0)) : item.icon ? (_jsx("div", __assign({ className: "headline-cta-section-icon" }, { children: parse(item.icon) }), void 0)) : (''),
                                _jsxs("div", __assign({ className: "headline-cta-section-icon-item-heading" }, { children: [item.title && (_jsx("div", __assign({ className: "headline-cta-section-icon-item-title" }, { children: parse(item.title) }), void 0)),
                                        item.description && (_jsx("div", __assign({ className: "headline-cta-section-icon-item-description" }, { children: parse(item.description) }), void 0))] }), void 0),
                                item.cta && item.cta.url && item.cta.title && (_jsx(_Fragment, { children: chosentheme.backgroundColor &&
                                        chosentheme.backgroundColor !== '#ffffff' ? (_jsx("a", __assign({ className: "headline-cta-section-icon-item-cta-link", href: item.cta.url }, (item.cta.is_external && {
                                        target: '_blank',
                                        rel: 'norefferer',
                                    }), { children: _jsx(Button, __assign({ classes: [
                                                'text-enblue-500',
                                                'focus:bg-enblue-light',
                                                'ArticleButtons_custom',
                                                'headline-cta-section-icon-item-cta-button',
                                            ], animate: "animate-white" }, { children: _jsx("div", __assign({ className: "headline-cta-section-icon-item-cta", style: {
                                                    color: chosentheme.ctaStyle.color,
                                                } }, { children: parse(item.cta.title) }), void 0) }), void 0) }), void 0)) : (_jsx("a", __assign({ className: "headline-cta-section-icon-item-cta-link", href: item.cta.url }, (item.cta.is_external && {
                                        target: '_blank',
                                        rel: 'norefferer',
                                    }), { children: _jsx(PrimaryButton, __assign({ className: "headline-cta-section-icon-item-cta-button primary-button" }, { children: _jsx("div", __assign({ className: "headline-cta-section-icon-item-cta", style: {
                                                    color: chosentheme.ctaStyle.color,
                                                } }, { children: parse(item.cta.title) }), void 0) }), void 0) }), void 0)) }, void 0))] }), index));
                    }) }), void 0)] }), void 0)) : template == 'stat-text-cta' ? (_jsxs("div", __assign({ className: "headline-cta-section relative snap-center w-full h-full flex items-center justify-center " + (headlineCTAStatItemsCount == 4 ? 'four-items' : '') + " " + chosentheme.class, style: chosentheme }, { children: [background_image && (_jsx("div", { className: "headline-cta-section-overlay" }, void 0)),
                _jsxs("div", __assign({ className: "headline-cta-section-heading" }, { children: [headline && (_jsx("div", __assign({ className: "headline-cta-section-title" }, { children: parse(headline) }), void 0)),
                        description && (_jsx("div", __assign({ className: "headline-cta-section-description stat-text-cta" }, { children: _jsx("div", { children: parse(description) }, void 0) }), void 0))] }), void 0),
                _jsx("div", __assign({ className: "headline-cta-section-stats-items-container" }, { children: items.map(function (item, index) {
                        return (_jsxs("div", __assign({ className: "headline-cta-section-stats-item " + (headlineCTAStatItemsCount == 4 ? 'four-items' : '') }, { children: [_jsx("div", __assign({ className: "headline-cta-section-stats " + (headlineCTAStatItemsCount == 4 ? 'four-items' : '') + " ", style: { color: chosentheme.statsColor } }, { children: item.title && _jsx("div", { children: parse(item.title) }, void 0) }), void 0),
                                item.description && (_jsx("div", __assign({ className: "headline-cta-section-stats-item-description" }, { children: parse(item.description) }), void 0)),
                                item.cta && item.cta.url && item.cta.title && (_jsx(_Fragment, { children: chosentheme.backgroundColor &&
                                        chosentheme.backgroundColor !== '#ffffff' ? (_jsx("a", __assign({ className: "headline-cta-section-stats-item-cta-link", href: item.cta.url }, (item.cta.is_external && {
                                        target: '_blank',
                                        rel: 'norefferer',
                                    }), { children: _jsx(Button, __assign({ classes: [
                                                'text-enblue-500',
                                                'focus:bg-enblue-light',
                                                'ArticleButtons_custom',
                                                'headline-cta-section-stats-item-cta-button',
                                            ], animate: "animate-white" }, { children: _jsx("div", __assign({ className: "headline-cta-section-stats-item-cta", style: {
                                                    color: chosentheme.ctaStyle.color,
                                                } }, { children: parse(item.cta.title) }), void 0) }), void 0) }), void 0)) : (_jsx("a", __assign({ className: "headline-cta-section-stats-item-cta-link", href: item.cta.url }, (item.cta.is_external && {
                                        target: '_blank',
                                        rel: 'norefferer',
                                    }), { children: _jsx(PrimaryButton, __assign({ className: "headline-cta-section-stats-item-cta-button" }, { children: _jsx("div", __assign({ className: "headline-cta-section-stats-item-cta", style: {
                                                    color: chosentheme.ctaStyle.color,
                                                } }, { children: parse(item.cta.title) }), void 0) }), void 0) }), void 0)) }, void 0))] }), index));
                    }) }), void 0)] }), void 0)) : ('') }, void 0));
};
export default HeadlineCTA;
HeadlineCTA.defaultProps = defaultProps;
